var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercentage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2846 9H17.7296C12.2696 9 9.01465 12.255 9.01465 17.715V30.27C9.01465 35.73 12.2696 38.985 17.7296 38.985H30.2846C35.7446 38.985 38.9996 35.73 38.9996 30.27V17.715C38.9996 12.255 35.7446 9 30.2846 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2296 30.0302C18.9446 30.0302 18.6596 29.9252 18.4346 29.7002C17.9996 29.2652 17.9996 28.5452 18.4346 28.1102L28.2596 18.2852C28.6946 17.8502 29.4146 17.8502 29.8496 18.2852C30.2846 18.7202 30.2846 19.4402 29.8496 19.8752L20.0246 29.7002C19.7996 29.9252 19.5146 30.0302 19.2296 30.0302Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.845 17.4902C18.63 17.4902 17.625 18.4803 17.625 19.7103C17.625 20.9253 18.615 21.9302 19.845 21.9302C21.06 21.9302 22.065 20.9403 22.065 19.7103C22.05 18.4803 21.06 17.4902 19.845 17.4902Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6545 26.0859C28.4395 26.0859 27.4346 27.0759 27.4346 28.3059C27.4346 29.5209 28.4245 30.5259 29.6545 30.5259C30.8695 30.5259 31.8746 29.5359 31.8746 28.3059C31.8746 27.0759 30.8845 26.0859 29.6545 26.0859Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.bade59c312ecc467889c2b16356400a9.svg";
export { ForwardRef as ReactComponent };